module.exports = __webpack_public_path__ + "img/guide_download.b9f26947.svg";